/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "5855f517adddec93d74bcfc2a214d47fe108850d";
